import type { Guide, GuideRecordHint } from '../types';

/**
 * S-24.10-07 — oś tachografu starsza niż 24 h: przeszłość zostaje (scenariusz e2e 27; decyzja użytkownika
 * 21.10.2026, C39). Rekord: DEMO 027 — kierowca Piotr DEMO Stary z osią tachografu kończącą się 30 h temu;
 * dane: `e2e/setup/seed-e2e.ts`, `gantt2410`.
 */
const CAR: GuideRecordHint = {
  description: 'pojazd, którego kierowca ma ostatni odczyt tachografu sprzed ponad doby',
  listPath: '/cars',
};

export const guide: Guide = {
  flagKey: 'staleTachographPast',
  title: 'Oś tachografu starsza niż 24 h — przeszłość zostaje',
  whatItDoes:
    'Gdy ostatni odczyt tachografu kierowcy jest starszy niż 24 h, wiersz „Aktywność kierowcy” na karcie pojazdu nie chowa już osi: rysuje zapisane wpisy z przeszłości z podpisem „ostatni odczyt … — starszy niż 24 h”. Przeszłość przewija się strzałkami osi, a „Pokaż ostatni odczyt” przenosi oś do dnia odczytu. „Teraz” i dalej to plan jazdy z obsadzeń (szacunek), nie dane z tachografu. Suma tygodnia liczy to, co jest, i mówi, do kiedy są dane. Rekomendacje dalej wymagają osi świeższej niż 24 h.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-24.10-07'],
  steps: [
    {
      route: '/cars/:carId/show',
      record: CAR,
      target: 'driver-activity-stale',
      title: 'Podpis „ostatni odczyt … — starszy niż 24 h”',
      description:
        'Przy wierszu „Aktywność kierowcy” stoi godzina ostatniego odczytu i informacja, że jest starszy niż 24 h. Dymek mówi, że „teraz” i dalej to plan z obsadzeń, a nie dane z tachografu.',
      action: 'Na karcie pojazdu w „Harmonogramie” spójrz na podpis wiersza „Aktywność kierowcy”.',
      recorder: { account: 'master', demo: { kind: 'car', plate: 'DEMO 027' } },
    },
    {
      route: '/cars/:carId/show',
      record: CAR,
      target: 'gantt-track-driver',
      title: 'Zapisane wpisy z przeszłości na osi',
      description:
        'Jazda, praca, przerwy i odpoczynki sprzed odczytu są narysowane jak przy świeżej osi i kończą się na chwili odczytu — luki do „teraz” niczym nie wypełniamy. Starsze dni zobaczysz, przewijając oś strzałkami; gdy odczyt jest poza kadrem, „Pokaż ostatni odczyt” przenosi oś do jego dnia.',
      action: 'Najedź na odcinek w wierszu „Aktywność kierowcy”, a potem przewiń oś wstecz.',
      recorder: { account: 'master', demo: { kind: 'car', plate: 'DEMO 027' } },
    },
  ],
};
